import {IExactGlobeConfiguration} from './erp-exactGlobe';
import {IExactOnlineConfiguration} from './erp-exactOnline';
import {ISapConfiguration} from './erp-sap';
import {IStandAloneConfiguration} from './erp-standalone';

export interface IErp {
  exactGlobeConfiguration: IExactGlobeConfiguration;
  exactOnlineConfiguration: IExactOnlineConfiguration;
  sapConfiguration: ISapConfiguration;
  standAloneConfiguration: IStandAloneConfiguration;
  type: Type;
}

export type Type = 'STAND_ALONE' | 'SAP' | 'SAPS4' | 'EXACT_ONLINE' | 'EXACT_GLOBE' | 'AFAS' | 'NET_SUITE';
export const TypeValues: Type[] = ['STAND_ALONE' , 'SAP' , 'SAPS4' , 'EXACT_ONLINE' , 'EXACT_GLOBE' , 'AFAS' , 'NET_SUITE'];

